var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetry(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 0.75L14.0146 1.86777C14.4189 2.62346 14.621 3.00131 14.4874 3.16313C14.3537 3.32495 13.9135 3.19426 13.0331 2.93288C12.1529 2.67155 11.2184 2.53095 10.25 2.53095C5.00329 2.53095 0.75 6.65846 0.75 11.75C0.75 13.4291 1.21262 15.0035 2.02093 16.3595M7.08333 22.75L6.48536 21.6322C6.08108 20.8765 5.87894 20.4986 6.0126 20.3368C6.14627 20.175 6.58649 20.3057 7.46689 20.5671C8.3471 20.8284 9.2816 20.969 10.25 20.969C15.4967 20.969 19.75 16.8415 19.75 11.75C19.75 10.0708 19.2874 8.49647 18.4791 7.14047",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetry);
export default __webpack_public_path__ + "static/media/Retry.1502e846122e1a4c39e92d7d8c0e8516.svg";
export { ForwardRef as ReactComponent };